import React from 'react'
import ProfileSettingsComp from '../../components/body/profile/ProfileSettingsComp'

const ProfileSettingsScreen = () => {
    return (
        <>
            <ProfileSettingsComp />
        </>
    )
}

export default ProfileSettingsScreen